import React from 'react';
import Loader from '../components/loader';
import HeroHeader from '../components/HeroHeader';
import CarrierSubPage from '../components/carrier-form';
import MetaTags from '../common-components/MetaTags';

class CarrierPage  extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    // document.title = "Carrier Form - Learn Quran Easily";
    // document.description = "Learn Quran Easily"
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000); // Simulate a 3-second loading delay
  }


  render() {
    const breadcrumbs = [
        { label: 'Home', href: '/', isCurrentPage: false },
        // { label: 'Pages', href: '#', isCurrentPage: false },
        { label: 'Career-Form', href: '#', isCurrentPage: true },
      ];

    return <>
    <MetaTags
      title="Career Form - Learn Quran Easily"
      description="Join Learn Quran Easily and build your Career with us. Explore exciting job opportunities and contribute to spreading authentic Islamic knowledge."
      keywords="Career Learn Quran Easily, Job Opportunities, Islamic Education Jobs, Online Quran Teaching Jobs, LQE Careers"
      author="Learn Quran Easily Team"
      url="https://learnquraneasily.in/career-form"
      image="https://lqe-assets.learnquraneasily.in/1747284949484_Lqe_logo.png"
    />
      {this.state.loading ? <Loader /> :
        <>
          <HeroHeader  title="Career Form" breadcrumbs={breadcrumbs} />
          <CarrierSubPage />
        </>}
    </>
  }
}

export default CarrierPage;
